import { useFeatureStore } from '@/stores/features';

declare global {
  interface Window {
    onLoadFeatures?: string | string[];
  }
}

const splitPipeSeparated = (value: string): string[] => {
  return value
    .split('|')
    .map((item) => item.trim())
    .filter(Boolean);
};

const normaliseFeatureNames = (value: string | string[] | undefined): string[] => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.map((item) => item.trim()).filter(Boolean);
  }

  return splitPipeSeparated(value);
};

const collectQueryFeatures = (key: string): string[] => {
  const searchParams = new URLSearchParams(window.location.search);
  const values = searchParams.getAll(key);

  return values.flatMap((value) => splitPipeSeparated(value));
};

export const initialiseFeatures = (): void => {
  const featureStore = useFeatureStore();

  const enableFeature = (name: string) => {
    featureStore.setFeature(name, true);
  };

  const disableFeature = (name: string) => {
    featureStore.setFeature(name, false);
  };

  normaliseFeatureNames(window.onLoadFeatures).forEach(enableFeature);
  collectQueryFeatures('featuresToEnable').forEach(enableFeature);
  collectQueryFeatures('featuresToDisable').forEach(disableFeature);

  document.addEventListener('enable:feature', (event: Event) => {
    const featureName = (event as CustomEvent<string>).detail;
    if (typeof featureName === 'string' && featureName.trim()) {
      enableFeature(featureName.trim());
    }
  });

  document.addEventListener('disable:feature', (event: Event) => {
    const featureName = (event as CustomEvent<string>).detail;
    if (typeof featureName === 'string' && featureName.trim()) {
      disableFeature(featureName.trim());
    }
  });
};
